module.exports = __webpack_public_path__ + "img/userA04.72fbbc02.jpg";